import type { User } from '@repo-level/core-front';
import { AuthMissedField } from '../constants';

export const isNeedAuthDataConfirmation = (user: User | undefined): boolean =>
  Array.isArray(user?.authFieldsMissed) &&
  (user?.authFieldsMissed as string[]).includes(AuthMissedField.Country);
